<template>
    <div class="wlx-login-register-wrapper">
        <div class="login-register-content clearfix">
            <div class="login-bg-img-con">
                <img :src="loginBg" alt class="bg-img-val" />
            </div>
            <div class="fr login-register-con">
                <p class="p-back-icon">
                    <i class="wl-icon-fanhui" @click="backToHome"></i>
                </p>
                <h1 class="h1-back-manager-title h1-get-password-title">物流后台管理平台</h1>
                <h1 class="h1-back-manager-title h1-get-password-title h1-get-password">找回密码</h1>
                <div class="login-register-form">
                    <div class="register-form-con">
                        <el-steps :active="activeIndex" finish-status="success">
                            <el-step title="确认账号"></el-step>
                            <el-step title="找回密码"></el-step> 
                        </el-steps>
                        <!-- :filter-method="filterSchool" -->
                        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
                            <el-form-item prop="schoolId" v-if="activeIndex == 0">
                                <el-select v-model="passwordForm.schoolId" clearable filterable placeholder="请选择学校">
                                    <el-option prefix-icon="yk-icon-xuexiao" v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="userName" v-if="activeIndex == 0">
                                <el-input v-model="passwordForm.userName" class="form_input" placeholder="请输入账号" maxlength="50"></el-input>
                            </el-form-item>

                            <el-form-item prop="phoneNum" v-if="activeIndex == 1">
                                <!-- <el-input v-model="passwordForm.phoneNum" placeholder="请输入手机号"></el-input> -->
                                {{ passwordForm.phoneNum }}
                            </el-form-item>
                            <el-form-item prop="verfyCode" v-if="activeIndex == 1">
                                <el-input v-model="passwordForm.verfyCode" placeholder="请输入验证码" style="width: 317px; margin-right: 20px"></el-input>
                                <el-button v-if="show1" type="primary" @click="sendMessage()" class="get-message-btn">获取验证码</el-button>
                                <el-button v-if="show2" type="primary" class="get-message-btn">{{ count }}s</el-button>
                                <el-button v-if="show3" type="primary" @click="sendMessage()" class="get-message-btn">重新获取验证码</el-button>
                            </el-form-item>
                            <el-form-item prop="password" v-if="activeIndex == 1">
                                <el-input :type="changePass" v-model="passwordForm.password" placeholder="请输入密码"></el-input>
                            </el-form-item>
                            <el-form-item prop="surePassword" v-if="activeIndex == 1">
                                <el-input :type="changePass" v-model="passwordForm.surePassword" placeholder="请再次输入密码"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="submit-login-btn" @click="getUserPhone" v-if="activeIndex == 0">下一步</div>
                        <div class="submit-login-btn" @click="complete('passwordForm')" v-if="activeIndex == 1">完成</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
export default {
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.passwordForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            show1: true,
            show2: false,
            show3: false,
            count: 60,
            loginBg: require("assets/images/wlx-login-bg.png"),
            btnName: "login",
            passwordForm: {
                schoolId: "",
                userName: "",
                phoneNum: "",
                password: "",
                surePassword: "",
                verfyCode: "",
            },
            changePass: "password",

            passwordRules: {
                role: [{ required: true, message: "请选择身份", trigger: "change" }],
                schoolId: [{ required: true, message: "请选择学校", trigger: "blur" }],
                userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
                // phoneNum: [
                //   { required: true, message: "请输入手机号", trigger: "blur" }
                // ],
                verfyCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                surePassword: [{ validator: validatePass2, trigger: "blur" }],
            },
            schoolList: [],
            backOptions: [],
            activeIndex: 0,
            userId: "",
        };
    },
    props: {
        source: {
            type: String,
            default: "",
        },
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function () {
            return this.$store.state.association;
        },
        target() {
            let Urlname = "";
            if (this.$store.state.auth.userType === 1) {
                Urlname = "stuBasicInfo";
            } else if (this.$store.state.auth.userType === 2) {
                Urlname = "teaApply";
            } else if (this.$store.state.auth.userType === 3) {
                Urlname = "siteBasicInfo";
            } else if (this.$store.state.auth.userType === 5) {
                Urlname = "managerIndex";
            }
            return { name: Urlname };
        },
    },
    created() {
        this.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
        this.getSchoolList();
    },
    watch: {
        association: {
            handler(val) {},
            deep: true,
        },
    },
    methods: {
        /* 获取学校信息 */
        getSchoolList() {
            var that = this;
            this.$http
                .post("/api/XOrg/XLogin/getSchoolList", {
                    SchoolType: "zwl",
                })
                .then((rst) => {
                    that.schoolList = rst.list;
                    that.backOptions = rst.list;
                });
        },
        // filterSchool: function(val) {
        //         var that = this;
        //         if (val) {
        //             // val存在
        //             that.schoolList = this.backOptions.filter(item => {
        //                 if (!!~item.name.indexOf(val) || !!~item.pinyin.indexOf(val)) {
        //                     return true;
        //                 }
        //             });
        //         } else {
        //             // val为空时，还原数组
        //             that.schoolList = this.backOptions;
        //         }
        //     },
        backToHome() {
            if (this.source == "ykt") {
                window.location.href = "https://ykt.clppx.org.cn/wlykt/home";
            } else {
                this.$router.push({
                    name: "xIndex",
                });
            }
        },
        complete(formName) {
            var that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert("submit!");
                    that.RetrievePwd();
                } else {
                    this.$message({
                        message: "请输入信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        // 发送验证码
        sendMessage() {
            var once = true;
            let str_ = Date.parse(new Date()) / 1000;
            let str = this.encryption(str_);
            let str1 = CryptoJS.MD5(str_ + "").toString();
            var s1 = str1.substring(0, 7);
            var s2 = str1.substring(7);
            console.log(this.passwordForm.phoneNum);
            str1 = s1 + "s" + s2;
            if (once) {
                var that = this;

                this.$http
                    .post("/api/XOrg/XLogin/sendCodeByUser", {
                        userId: that.userId,
                        str: str,
                        str1: str1,
                    })
                    .then((rst) => {
                        if (rst.code > 0) {
                            this.$message.success(rst.msg);
                            this.verifyCode = rst.verifyCode;
                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.count = TIME_COUNT;
                                this.show1 = false;
                                this.show2 = true;
                                this.show3 = false;
                                this.timer = setInterval(() => {
                                    if (this.count > 0 && this.count <= TIME_COUNT) {
                                        this.count--;
                                        once = false;
                                    } else {
                                        this.show1 = false;
                                        this.show2 = false;
                                        this.show3 = true;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                        once = true;
                                    }
                                }, 1000);
                            }
                        } else {
                            this.$message.warning(rst.msg);
                        }
                    });
            }
        },
        encryption: function (str) {
            let Base64 = require("js-base64").Base64;
            return Base64.encode(str);
        },
        roleTab(role) {
            this.isRoleTab = role;
        },
        // 登录后跳转
        roleEnter() {
            if (this.$store.state.auth.userType === 1) {
                this.$router.push({
                    name: "stuBasicInfo",
                });
            } else if (this.$store.state.auth.userType === 2) {
                this.$router.push({
                    name: "teaApply",
                });
            } else if (this.$store.state.auth.userType === 3) {
                this.$router.push({
                    name: "siteBasicInfo",
                });
            } else if (this.$store.state.auth.userType === 5) {
                this.$router.push({
                    name: "managerIndex",
                });
            }
        },
        // 确认账号
        getUserPhone() {
            var that = this;
            this.$http
                .post("/api/XOrg/XLogin/getUserPhone", {
                    schoolId: that.passwordForm.schoolId,
                    userName: that.passwordForm.userName,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        that.passwordForm.phoneNum = rst.info.mobile;
                        that.userId = rst.info.id;
                        that.activeIndex = 1;
                    } else {
                        that.$message({
                            message: rst.msg,
                            type: "warning",
                        });
                    }
                });
        },
        //重置密码
        RetrievePwd() {
            var that = this;
            this.$http
                .post("/api/XOrg/XLogin/RetrievePwd", {
                    userId: that.userId,
                    moblie: that.passwordForm.phoneNum,
                    shortMessage: that.passwordForm.verfyCode,
                    passWord: that.passwordForm.password,
                    associationId: that.association.Id,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        // that.onSubmitNext();
                        // that.$message({
                        //   message: rst.msg,
                        //   type: 'success'
                        // });
                        const h = that.$createElement;
                        that.$message({
                            message: h("div", null, [h("p", null, [h("span", { style: "color: #000" }, "密码更改成功")]), h("p", null, [h("span", { style: "color: #000" }, "正在跳转到登录页...")])]),
                            type: "success",
                            duration: 3000,
                        });
                        setTimeout(that.backToHome, 3000);
                    } else {
                        that.$message({
                            message: rst.msg,
                            type: "warning",
                        });
                    }
                });
        },

        autuLogin() {
            this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {
                this.loadingTip(false);
                this.roleEnter();
            });
        },
        loadingTip(is) {
            // let loading = null;
            if (is) {
                this.$loading({
                    lock: true,
                    text: "正在登录...",
                });
            } else {
                this.$loading({}).close();
            }
        },
    },
};
</script>

<style></style>
